__webpack_require__.p = "/assets/turbo/65715a0f/baurde/_next/";